import { homeSecurityPortalApi } from 'data/axios';
import { TPlanList, TSkipList, TSkipReason } from 'typings';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function birdSkipFreeTrialReason(payload: TSkipReason) {
  const response = await homeSecurityPortalApi.post(
    endpoints.birdSkipFreeTrialReason,
    payload
  );
  return response;
}

export async function birdSkipFreeTrialList(): Promise<
  ApiResponse<TSkipList[]>
> {
  const response = await homeSecurityPortalApi.get(
    endpoints.birdSkipFreeTrialList
  );
  return response;
}

export async function getBirdPlans(
  country: string
): Promise<ApiResponse<TPlanList[]>> {
  const response = await homeSecurityPortalApi.get(
    endpoints.getBirdPlansList(country)
  );
  return response;
}
